(function() {
    class FooterBlockAdev extends HTMLElement {
      constructor() {
        super();

        this.id = this.dataset.id;
      }

      connectedCallback() {
        this.setupAccessibility();
        this.setupMobileAccordion();
      }

      setupAccessibility() {
        const links = this.querySelectorAll(`.ai-footer-link-${this.id}`);
        links.forEach(link => {
          if (!link.getAttribute('href') || link.getAttribute('href') === '') {
            link.setAttribute('tabindex', '-1');
            link.style.pointerEvents = 'none';
            link.style.opacity = '0.5';
          }
        });
      }

      setupMobileAccordion() {
        const columns = this.querySelectorAll(`.ai-footer-column-${this.id}`);
        
        columns.forEach(column => {
          const title = column.querySelector(`.ai-footer-column-title-${this.id}`);
          
          if (title) {
            title.addEventListener('click', () => {
              if (window.innerWidth <= 749) {
                const isActive = column.classList.contains('active');
                
                columns.forEach(col => col.classList.remove('active'));
                
                if (!isActive) {
                  column.classList.add('active');
                }
              }
            });
          }
        });

        window.addEventListener('resize', () => {
          if (window.innerWidth > 749) {
            columns.forEach(col => col.classList.remove('active'));
          }
        });
      }
    }

    customElements.define('footer-block-adev', FooterBlockAdev);
  })();